import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface NotificationTriggersProps {
  preferences?: {
    notifyOnVivid?: boolean | null;
    notifyOnGreat?: boolean | null;
    notifyOnGood?: boolean | null;
  } | null;
  onToggle: (field: string, value: boolean) => void;
}

export function NotificationTriggers({ preferences, onToggle }: NotificationTriggersProps) {
  return (
    <Card className="card-elevated border-none shadow-premium">
      <CardHeader>
        <CardTitle>Notification Triggers</CardTitle>
        <CardDescription>
          Choose which quality levels should trigger notifications
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="notify-vivid" className="flex-1 cursor-pointer">
            <div>
              <p className="font-medium">Vivid conditions</p>
              <p className="text-sm text-muted-foreground">
                Exceptional, once-in-a-week quality (90-100%)
              </p>
            </div>
          </Label>
          <Switch
            id="notify-vivid"
            checked={preferences?.notifyOnVivid ?? true}
            onCheckedChange={(checked) => onToggle("notifyOnVivid", checked)}
          />
        </div>

        <div className="flex items-center justify-between">
          <Label htmlFor="notify-great" className="flex-1 cursor-pointer">
            <div>
              <p className="font-medium">Great conditions</p>
              <p className="text-sm text-muted-foreground">
                Excellent photography opportunities (75-89%)
              </p>
            </div>
          </Label>
          <Switch
            id="notify-great"
            checked={preferences?.notifyOnGreat ?? true}
            onCheckedChange={(checked) => onToggle("notifyOnGreat", checked)}
          />
        </div>

        <div className="flex items-center justify-between">
          <Label htmlFor="notify-good" className="flex-1 cursor-pointer">
            <div>
              <p className="font-medium">Good conditions</p>
              <p className="text-sm text-muted-foreground">
                Decent quality, worth considering (60-74%)
              </p>
            </div>
          </Label>
          <Switch
            id="notify-good"
            checked={preferences?.notifyOnGood ?? false}
            onCheckedChange={(checked) => onToggle("notifyOnGood", checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
}

